export const DEFAULT_LOGO_URL = 'https://res.cloudinary.com/'
                                + 'hyvpafifu/image/upload/v1757259548/jyogui/'
                                + 'logo/jyogui-mini-logo_edited_nh3hs0.jpg';

export const DEFAULT_FACEBOOK_URL = 'http://www.facebook.com/jyoguiapp';
export const DEFAULT_YOUTUBE_URL = 'https://www.youtube.com/@jyoguiapp';
export const DEFAULT_INSTAGRAM_URL = 'http://www.instagram.com/jyoguiapp';
export const DEFAULT_TIKTOK_URL = 'http://www.tiktok.com';
export const DEFAULT_WEBSITE_URL = 'http://www.jyogui.fr';
export const DEFAULT_MAILTO = 'info@jyogui.fr';
export const DEFAULT_TELEPHONE = '';



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/layout.constants.ts